import { useState } from 'react';
import { ChevronDown, X, Check } from 'lucide-react';

interface CustomSelectProps {
  value: string;
  onChange: (value: string) => void;
  options: { value: string; label: string }[];
  placeholder?: string;
  label?: string;
}

export default function CustomSelect({ value, onChange, options, placeholder = '请选择', label }: CustomSelectProps) {
  const [isOpen, setIsOpen] = useState(false);
  const selectedLabel = options.find(o => o.value === value)?.label || placeholder;

  return (
    <div className="relative">
      {label && <label className="block text-avalon-text text-xs mb-1">{label}</label>}
      <button
        onClick={() => setIsOpen(true)}
        className="w-full p-2 rounded-lg bg-avalon-card text-white border border-avalon-purple/30 hover:border-avalon-purple transition-colors text-sm flex items-center justify-between"
      >
        <span>{selectedLabel}</span>
        <ChevronDown className="w-4 h-4 text-avalon-text" />
      </button>

      {isOpen && (
        <div
          className="fixed inset-0 z-50 flex items-center justify-center p-4"
          onClick={() => setIsOpen(false)}
        >
          <div className="absolute inset-0 bg-black/60 backdrop-blur-sm" />
          <div
            className="relative w-full max-w-sm bg-gradient-to-br from-[#2A1F3D] to-[#1E1A30] rounded-2xl border border-purple-500/30 shadow-2xl shadow-purple-500/20 overflow-hidden"
            onClick={e => e.stopPropagation()}
          >
            <div className="p-4 border-b border-purple-500/20 flex items-center justify-between">
              <h3 className="text-white font-bold flex items-center gap-2">
                <span className="w-8 h-8 rounded-lg bg-gradient-to-br from-avalon-purple to-purple-600 flex items-center justify-center text-lg">
                  {label === '道场' ? '🏯' : label === '赛季' ? '🏆' : '📋'}
                </span>
                {label || '选择'}
              </h3>
              <button
                onClick={() => setIsOpen(false)}
                className="p-2 rounded-lg hover:bg-white/10 text-avalon-text transition-colors"
              >
                <X className="w-5 h-5" />
              </button>
            </div>

            <div className="p-2 max-h-72 overflow-y-auto">
              {options.map((option) => (
                <button
                  key={option.value}
                  onClick={() => {
                    onChange(option.value);
                    setIsOpen(false);
                  }}
                  className={`w-full p-3 rounded-xl mb-1 flex items-center justify-between transition-all ${
                    value === option.value
                      ? 'bg-gradient-to-r from-avalon-purple/50 to-purple-500/30 border border-avalon-purple/50'
                      : 'hover:bg-white/5 border border-transparent'
                  }`}
                >
                  <span className={`font-medium ${value === option.value ? 'text-white' : 'text-avalon-text'}`}>
                    {option.label}
                  </span>
                  {value === option.value && (
                    <div className="w-6 h-6 rounded-full bg-avalon-gold flex items-center justify-center">
                      <Check className="w-4 h-4 text-avalon-bg-dark" />
                    </div>
                  )}
                </button>
              ))}
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
